import { LightGridWebComponent } from './component/LightGridWebComponent';
import { WEB_COMPONENT_LIGHT_GRID } from '../../webcomponents.constants';

export { LightGridWebComponent };

window.customElements.define(WEB_COMPONENT_LIGHT_GRID, LightGridWebComponent);
